import { Component } from '@angular/core';

@Component({
  selector: 'pdf-findbar-options-two-container',
  templateUrl: './pdf-findbar-options-two-container.component.html',
  styleUrls: ['./pdf-findbar-options-two-container.component.css'],
})
export class PdfFindbarOptionsTwoContainerComponent {}
